import { Card, CardContent, makeStyles, Typography } from "@material-ui/core";
import { useParams } from "react-router-dom";
import useLocale from "../../../../hooks/useLocale";
import CustomAlert from "../../../components/CustomAlert";
import { useField } from "formik";
import { useEffect } from "react";

const Header = ({ error, setError, applicationKinds, port_auth }) => {
  const { t } = useLocale();

  const classes = useStyles();
  const { id } = useParams();
  const portAuth = useField("portAuthority");

  useEffect(() => {
    console.log(portAuth?.[0].value);
  }, [portAuth?.[0].value]);

  return (
    <>
      <CustomAlert
        open={error}
        severity="error"
        close={() => {
          setError("");
        }}
        message={t(error)}
      />

      <Card>
        <CardContent className={classes.contentCard}>
          {/* Application kind label */}
          <div className={classes.insideContentMargin}>
            <Typography variant="subtitle2" color="textSecondary">
              {t("Application kind")}
            </Typography>
            <Typography variant="h4" gutterBottom>
              {applicationKinds?.find((applKind) => applKind.id == id)?.dscr}
            </Typography>
          </div>

          {/* Current Status */}
          <div className={classes.insideContentMargin}>
            <Typography variant="subtitle2" color="textSecondary">
              {t("Status")}
            </Typography>
            <Typography variant="h4" gutterBottom>
              {t("New application")}
            </Typography>
          </div>

          {/* Port authority */}
          <div className={classes.insideContentMargin}>
            <Typography variant="subtitle2" color="textSecondary">
              {t("Port Authority")}
            </Typography>
            <Typography variant="h4" gutterBottom>
              {portAuth?.[0]?.value?.dscr || port_auth}
            </Typography>
          </div>
        </CardContent>
      </Card>
    </>
  );
};

const useStyles = makeStyles(() => ({
  contentCard: {
    display: "flex",
  },
  insideContentMargin: {
    marginRight: "2rem",
  },
}));

export default Header;
